import { createActionCreator } from 'utils';

const { createActionWithStatuses } = createActionCreator('User profile');

export const [fetchUserProfile, fetchUserProfileSuccess] =
  createActionWithStatuses('Fetch user profile');
export const [createUserProfile] = createActionWithStatuses(
  'Create user profile',
  (userProfileData, callbacks) => ({ userProfileData, callbacks })
);
export const [updateUserProfile, updateUserProfileSuccess] = createActionWithStatuses(
  'Update user profile',
  (userProfileData, callbacks) => ({ userProfileData, callbacks })
);
export const [uploadCoverPhoto, uploadCoverPhotoSuccess, uploadCoverPhotoFailure] =
  createActionWithStatuses('Upload cover photo');
export const [uploadProfilePhoto, uploadProfilePhotoSuccess, uploadProfilePhotoFailure] =
  createActionWithStatuses('Upload profile photo');
export const [updateWidgetsSettings] = createActionWithStatuses('Update widgets settings');
